import { render, staticRenderFns } from "./OrderWesmart.vue?vue&type=template&id=015fedb1&scoped=true"
import script from "./OrderWesmart.vue?vue&type=script&lang=js"
export * from "./OrderWesmart.vue?vue&type=script&lang=js"
import style0 from "./OrderWesmart.vue?vue&type=style&index=0&id=015fedb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fedb1",
  null
  
)

export default component.exports